export default "__VITE_ASSET__C87k6BBK__"